import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import storyCss from '../assets/story-item.module.scss';

type PropsType = {
  onClick?: () => void;
  additionalClassName?: string;
  dataId?: number;
};

const StoryItemContainer: FC<PropsWithChildren<PropsType>> = ({
  children,
  onClick,
  additionalClassName = null,
  dataId,
}) => (
  <div
    className={classNames(storyCss.storyItem, additionalClassName)}
    onClick={onClick}
    role="presentation"
    data-id={dataId}
  >
    {children}
  </div>
);

export { StoryItemContainer };
